import { useEffect, useRef, useState } from 'react';
import { IMAGE_CIRCLES } from '../../../assets';
import Lottie from 'react-lottie';
import * as floatingManAnimData from '../../../assets/Json/FLOATINGMAN.json';
import CustomRandomReveal from '../../../ultils/CustomRandomReveal';
import { useSwiperSlide } from 'swiper/react';
import { SentenceScramble } from '../../../ultils/SentenceScramble';
import { getSettingGifDefault } from '../../../ultils/getSettingGif';

interface SwiperProps {
  footerType: number;
  handlePrevStep: () => void;
  handleNextStep: () => void;
}

export default function Intro(swiperProps: SwiperProps) {
  const { handlePrevStep, handleNextStep } = swiperProps;
  const swiperSlide = useSwiperSlide();
  const hasScrambledOnce = useRef(false); // persists across renders
  const [updateState, setUpdateState] = useState(false);
  
  // Bean:  This is to update the state change so that the CustomRandomReveal only
  //        plays after the Sentence Scramble has done playing
  const _changeStateSentenceScrambler = () => {
    setUpdateState(true);
  }
  const sentenceScrambler = new SentenceScramble('intro-scrambler', _changeStateSentenceScrambler);

  useEffect(() => {
    if (swiperSlide.isActive && !hasScrambledOnce.current) {
      sentenceScrambler.startSequentialScramble(0.1);
      hasScrambledOnce.current = true;
    }
  }, [swiperSlide?.isActive]);

  useEffect(() => {
    const handleScroll = (e: any) => {
      e.preventDefault();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', handleScroll, { passive: false });

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const _renderTextName = (titles: string[]) => {
    const [count, setCount] = useState(0);
    const caret = document.getElementsByClassName("typewriter-container")[0];

    return (
      <>
        {updateState ?
          <>
            <span className='description-intro-mobile intro-scrambler'>highly skilled</span>
            <span style={{ whiteSpace: 'pre-wrap' }}> </span>
            <span className="typewriter-container pause">
              <CustomRandomReveal
                previous={titles[count]}
                next={titles[count === titles.length - 1 ? 0 : count + 1]}
                interval={100}
                delay={2}
                caret={caret}
                onComplete={() => {
                  if (count === titles.length - 1) {
                    setCount(0);
                  }
                  else {
                    setCount(count + 1);
                  }
                }}
              />
            </span>
          </>
          :
          <span className='description-intro-mobile intro-scrambler'>highly skilled creatives</span>
        }
      </>
    )
  };

  const _renderContent = () => {
    return (
      <div className='intro-container-mobile'>
        <p className='text-gray intro-scrambler'>{`< Intro >`}</p>
        <div>
          <span className='description-intro-mobile intro-scrambler'>We run on experimentation and </span>
          <span className='description-intro-mobile intro-scrambler'>creativity.Invented from Advertising and </span>
          <span className='description-intro-mobile intro-scrambler'>Production spheres, The Other Lab thrives </span>
          <span className='description-intro-mobile intro-scrambler'>on materialising ideas with a team of </span>
          {_renderTextName(['creatives', 'suits', 'developers', 'programmers', 'artists', 'illustrators', 'designers'])}
        </div>
        <p className={'text-gray-carrot'}>{'<>'}</p>
        <div className="image-group-container">
          <p className='text-start-intro intro-scrambler'>CONCOCTING</p>
          <p className='text-end-intro intro-scrambler'>CHAOS</p>
          <img src={IMAGE_CIRCLES} alt={""} className={'image__circle-home-intro'} />
          <div className={'image-home-intro'}>
            <Lottie
              options={getSettingGifDefault(floatingManAnimData)}
              width={'100%'}
              height={'auto'}
              isClickToPauseDisabled
            />
          </div>
        </div>
      </div>
    )
  };

  return (
    <div className={'div-loading-container'}>
      {_renderContent()}
      {/*<FooterMobile*/}
      {/*  footerType={PAGE_MOBILE.INTRO}*/}
      {/*  handlePrevStep={handlePrevStep}*/}
      {/*  handleNextStep={handleNextStep}*/}
      {/*/>*/}
    </div>
  )
}
